var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41797 1.66726C5.41793 1.61785 5.40324 1.56956 5.37577 1.52848C5.34829 1.48741 5.30926 1.4554 5.26361 1.4365C5.21796 1.41759 5.16772 1.41264 5.11926 1.42227C5.07079 1.4319 5.02626 1.45568 4.9913 1.49059L2.65797 3.82393C2.61115 3.8708 2.58486 3.93434 2.58486 4.00059C2.58486 4.06684 2.61115 4.13039 2.65797 4.17726L4.9913 6.51059C5.02626 6.54551 5.07079 6.56929 5.11926 6.57892C5.16772 6.58854 5.21796 6.58359 5.26361 6.56469C5.30926 6.54579 5.34829 6.51378 5.37577 6.4727C5.40324 6.43163 5.41793 6.38334 5.41797 6.33393L5.41797 1.66726Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.bd7a98bcaef937ee553fe6e71228e434.svg";
export { ForwardRef as ReactComponent };